import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  handleChildNavigation: (event: MessageEvent) => void;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  bookingOrigin: string;
}

export const useBookingEffects = ({
  handleChildNavigation,
  iframeRef,
  bookingOrigin,
}: Props) => {
  const location = useLocation();

  useEffect(() => {
    window.addEventListener('message', handleChildNavigation);
    return () => {
      window.removeEventListener('message', handleChildNavigation);
    };
  }, [handleChildNavigation]);

  useEffect(() => {
    const win = iframeRef.current?.contentWindow;
    if (!win) return;

    win.postMessage(
      {
        type: 'ROUTE_CHANGE',
        path: location.pathname,
        search: location.search,
        hash: location.hash,
      },
      bookingOrigin
    );
  }, [
    location.pathname,
    location.search,
    location.hash,
    bookingOrigin,
    iframeRef,
  ]);
};
